import { Record, Map } from "immutable";
import { EventResultReasonRecord, eventResultReasonFromJSON } from "common/records/EventResultReason";
import { RootActions, RootState } from "common/reducers";
import {
  EventResultReasonActions,
  RECEIVE_EVENT_RESULT_REASON,
  RECEIVE_EVENT_RESULT_REASONS,
} from "common/reducers/eventResultReason.actions";
import { receive } from "common/reducers/Utils";

export const EventResultReasonStateRecord = Record({
  byId: Map<number, EventResultReasonRecord>(),
});

export const initialState = EventResultReasonStateRecord();
export type EventResultReasonState = typeof initialState;

export const model = "eventResultReasons";
export const reducer = (state: RootState, action: RootActions): RootState => {
  switch (action.type) {
    case RECEIVE_EVENT_RESULT_REASON:
      return receive(state, model, eventResultReasonFromJSON(action.payload.resultReason));

    case RECEIVE_EVENT_RESULT_REASONS:
      action.payload.resultReasons.forEach((resultReason) => {
        state = reducer(state, EventResultReasonActions.receiveEventResultReason(resultReason));
      });
      return state;

    default:
      return state;
  }
};
